<template>
  <div class="cp-preview">
    <div class="cp-preview__bar">
      <md-icon class="cp-preview__icon">visibility</md-icon>
      <span class="cp-preview__label">{{ label || 'Preview' }}</span>
      <span class="cp-preview__hint">{{ hint || 'Live preview of how this step looks in the checkout' }}</span>
    </div>
    <!-- The stage is non-interactive: it only shows how the live texts render.
         pointer-events:none keeps buttons/inputs in the replicated step inert. -->
    <div class="cp-preview__stage">
      <div class="cp-preview__canvas">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Shared chrome for a checkout-step preview: a labelled bar + a read-only stage
 * that hosts a CRM-side replica of the real checkout step. The stage disables
 * pointer interaction so the preview can reuse the step's real markup/styles
 * without anything being clickable.
 */
export default {
  name: 'PreviewFrame',
  props: {
    label: { type: String, default: '' },
    hint: { type: String, default: '' }
  }
};
</script>

<style scoped>
.cp-preview {
  margin-top: 1.25rem;
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.cp-preview__bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: #f5f6f8;
  border-bottom: 1px solid #e8e8e8;
}
.cp-preview__icon { font-size: 18px !important; color: #8a929c !important; }
.cp-preview__label { font-weight: 700; font-size: 0.82rem; color: #4a5159; letter-spacing: 0.02em; }
.cp-preview__hint { font-size: 0.75rem; color: #9aa0a8; }

.cp-preview__stage {
  padding: 1.5rem;
  background:
    repeating-linear-gradient(45deg, #fafbfc, #fafbfc 10px, #f5f6f8 10px, #f5f6f8 20px);
}
/* The canvas mimics the white checkout content area. pointer-events:none makes
   the whole replica inert — it is a preview, never an interactive form. */
.cp-preview__canvas {
  pointer-events: none;
  user-select: none;
  max-width: 720px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
  padding: 24px;
}
</style>
